import { KNOWLEDGE_BASE_ENTRY_TYPES } from "@/constants/knowledge-base-entry-types"
import { transport, useTransportQuery } from "@/transport"

import type { KnowledgeBaseEntryResource } from "@/types_api/backend/transport/list_knowledge_base_entries_response"

import type { KnowledgeBaseEntry } from "../types"

export const FALLBACK_KNOWLEDGE_BASE_ENTRY_TYPE = "plain_text" as const
export const LIST_KNOWLEDGE_BASE_ENTRIES_OPERATION =
  transport.operations.listKnowledgeBaseEntries
export const LIST_KNOWLEDGE_BASE_ENTRIES_BY_TEST_SET_OPERATION =
  transport.operations.listKnowledgeBaseEntriesByTestSet

function isKnowledgeBaseEntryType(
  type: KnowledgeBaseEntryResource["type"],
): type is KnowledgeBaseEntry["type"] {
  return KNOWLEDGE_BASE_ENTRY_TYPES.includes(type as KnowledgeBaseEntry["type"])
}

export function mapKnowledgeBaseEntryResource(
  entry: KnowledgeBaseEntryResource,
): KnowledgeBaseEntry {
  return {
    id: entry.id,
    agent_id: entry.agent_id,
    name: entry.name,
    description: entry.description ?? undefined,
    s3_key: entry.s3_key ?? undefined,
    s3_bucket: entry.s3_bucket ?? undefined,
    text_content: entry.text_content ?? undefined,
    json_content: entry.json_content ?? null,
    type: isKnowledgeBaseEntryType(entry.type)
      ? entry.type
      : FALLBACK_KNOWLEDGE_BASE_ENTRY_TYPE,
    metadata: entry.metadata ?? undefined,
    test_set_id: entry.test_set_id ?? undefined,
    is_cdd: entry.is_cdd ?? undefined,
    created_at: entry.created_at,
    last_updated_at: entry.last_updated_at,
  }
}

export function useKnowledgeBaseEntriesTransport(
  agentId: string | null | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useTransportQuery({
    operation: LIST_KNOWLEDGE_BASE_ENTRIES_OPERATION,
    request: { agent_id: agentId || "" },
    options: {
      enabled: enabled && Boolean(agentId),
      select: (data) => data.entries.map(mapKnowledgeBaseEntryResource),
    },
  })
}

export function useKnowledgeBaseEntriesByTestSetTransport(
  testSetId: string | null | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useTransportQuery({
    operation: LIST_KNOWLEDGE_BASE_ENTRIES_BY_TEST_SET_OPERATION,
    request: { test_set_id: testSetId || "" },
    options: {
      enabled: enabled && Boolean(testSetId),
      select: (data) => data.entries.map(mapKnowledgeBaseEntryResource),
    },
  })
}
